import PropTypes from 'prop-types';
import React, {Fragment, forwardRef, useState} from 'react';
import {Button, Menu, Tooltip} from '@mui/material';

/**
 * A button component for the NavBar menu
 */
export const NavButton = forwardRef(
  ({title, children, disabled, ...props}, ref) => {
    return (
      <Tooltip title={title || ''} placement="bottom">
        <span>
          <Button
            sx={{
              '&:not(:first-of-type)': {ml: 1},
              width: 34,
              height: 34,
              minWidth: 34,
              '&.Mui-disabled': {
                pointerEvents: 'auto',
              },
            }}
            color="inherit"
            size="small"
            ref={ref}
            disabled={disabled}
            {...props}
          >
            {children}
          </Button>
        </span>
      </Tooltip>
    );
  },
);

NavButton.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

const NavMenuButton = ({label, children, ...props}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = React.Children.toArray(children).map(child =>
    React.cloneElement(child, {
      onClick: event => {
        handleClose(event);
        if (child.props.onClick) {
          child.props.onClick();
        }
      },
    }),
  );

  return (
    <Fragment>
      <NavButton onClick={handleClick} {...props}>
        {label}
      </NavButton>
      <Menu
        sx={{
          '& .MuiMenu-paper': {
            minWidth: 200,
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        {menuItems}
      </Menu>
    </Fragment>
  );
};

NavMenuButton.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node,
};

export default NavMenuButton;
